import './style/index.js';

import _Card from './Card';

export type { CardProps } from './Card';

export const Card = _Card;

export default Card;
